export function getOgImage(url: string) {
  // Replace any existing w_/h_ with OG defaults
  return url.replace(
    /upload\/(.*?)\//,
    "upload/f_auto,q_auto,c_fill,g_auto,w_1200,h_630/"
  );
}